export default __webpack_public_path__ + "images/ee823ee196657b4371aa4183e9ef0fba.png";